import type { Nil } from "@mcwd/typescript-type-guards";
import type { LinkDownloadType } from "assets/mcui-js/tracking/LinkDownloadType.js";

export interface CtaElementData {
  getCtaText(): string;
  getCtaClassList(): string | Nil;
  getCtaType(): LinkDownloadType | Nil;
  getBasicStyles(): unknown;
}
export class EmptyElement implements CtaElementData {
  private Message: string;
  constructor(message: string) {
    this.Message = message;
  }
  getCtaText(): string {
    return this.Message;
  }
  getCtaClassList() {
    return null;
  }
  getCtaType() {
    return null;
  }
  getBasicStyles() {
    return null;
  }
}

type CssDeclarationKeys =  keyof CSSStyleDeclaration;
function GetStylesFromElement<K extends CssDeclarationKeys>(el: JQuery<HTMLElement>, props:K[]){
  const element = el.get(0) as Element;
  const cssObj = window.getComputedStyle(element);
  const result: Pick<CSSStyleDeclaration, K> = {} as Pick<CSSStyleDeclaration, K>;
  for(const key of props){
    result[key] = cssObj[key];
  }
  return result;
}

export class ImageElement implements CtaElementData {

  private CtaElement: JQuery<HTMLElement>;
  private CtaType: LinkDownloadType = 'image';
  private StyleKeys: CssDeclarationKeys[] = ["height", "width"];

  constructor(element: JQuery<HTMLElement>) {
    this.CtaElement = element;
  }
  #findImageSrc(CtaElement: JQuery<HTMLElement>){
    if(CtaElement.is('img, iframe')){
      return CtaElement.attr('src');
    }

    const bgImage = CtaElement.css('background-image');
    if (bgImage && bgImage !== 'none') {
      const match = bgImage.match(/url\(['"]?(.*?)['"]?\)/i);
      if (match) {
        return match[1];
      }
    }
    if (CtaElement.is('picture')) {
    const img = CtaElement.find('img');
    if (img.length) return img.attr('src');
    
    const source = CtaElement.find('source').last();
    if (source.length) return source.attr('srcset') || source.attr('src');
    }
    return this.#FindImageInChildren(CtaElement);
  }
  #FindImageInChildren(CtaElement: JQuery<HTMLElement>){
    let ImageSource = "";
    const children = CtaElement.children().toArray();
    for(const child of children){
      const childSrc = this.#findImageSrc($(child));
      if (childSrc) {
        ImageSource = childSrc;
      }
    }
    return ImageSource;
  }
  getCtaText = () => {
    //const srcPath = this.CtaElement.prop("src");
    const srcPath = this.#findImageSrc(this.CtaElement);

    if (!srcPath) return "";
    
    const url = new URL(srcPath, window.location.origin);
    
    // Get the pathname and extract filename
    const pathSegments = url.pathname.split("/");
    return pathSegments[pathSegments.length - 1];
  };

  getCtaClassList = () => { return this.CtaElement.attr('class') as string; };

  getCtaType = () => { return this.CtaType; };

  getBasicStyles() {
    return GetStylesFromElement(this.CtaElement, this.StyleKeys);
  }
}
export class ButtonElement implements CtaElementData {

  private CtaElement: JQuery<HTMLElement>;
  private CtaType: LinkDownloadType = 'button';

  constructor(element: JQuery<HTMLElement>) {
    this.CtaElement = element;
  }
  getCtaText = () => { return this.CtaElement.text().replace(/\s+/g, ' ').trim(); };

  getCtaClassList = () => { return this.CtaElement.attr('class') as string; };

  getCtaType = () => { return this.CtaType; };

  getBasicStyles() {
    const element = this.CtaElement.get(0) as Element;
    const cssObj = window.getComputedStyle(element);
    return {
      "height": cssObj.height,
      "width": cssObj.width,
      "background": cssObj.background,
      "fontStyle": cssObj.fontStyle,
      "fontSize": cssObj.fontSize,
    };
  }
}
export class LinkElement implements CtaElementData {

  private CtaElement: JQuery<HTMLElement>;
  private CtaType: LinkDownloadType = 'text';

  constructor(element: JQuery<HTMLElement>) {
    this.CtaElement = element;
  }
  getCtaText = () => { return this.CtaElement.text().trim(); };

  getCtaClassList = () => { return this.CtaElement.attr('class') as string; };

  getCtaType = () => { return this.CtaType; };

  getBasicStyles() {
    const element = this.CtaElement.get(0) as Element;
    const cssObj = window.getComputedStyle(element);
    return {
      "height": cssObj.height,
      "width": cssObj.width,
      "backColor": cssObj.backgroundColor,
      "fontStyle": cssObj.fontStyle,
      "fontSize": cssObj.fontSize,
      "fontColor": cssObj.color,
    };
  }
}
